import { objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { createStyles } from '@mantine/styles';

var useStyles = createStyles(function (theme, _ref) {
  var size = _ref.size;
  return {
    item: _objectSpread2(_objectSpread2({}, theme.fn.fontStyles()), {}, {
      boxSizing: 'border-box',
      textAlign: 'left',
      width: '100%',
      padding: "".concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5, "px ").concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }), "px"),
      cursor: 'pointer',
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
      borderRadius: theme.fn.radius(),
      '&[data-hovered]': {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[1]
      },
      '&[data-selected]': _objectSpread2({
        backgroundColor: theme.fn.variant({
          variant: 'filled'
        }).background,
        color: theme.fn.variant({
          variant: 'filled'
        }).color
      }, theme.fn.hover({
        backgroundColor: theme.fn.variant({
          variant: 'filled'
        }).hover
      })),
      '&[data-disabled]': {
        cursor: 'default',
        color: theme.colors.dark[2]
      }
    }),
    nothingFound: {
      boxSizing: 'border-box',
      color: theme.colors.gray[6],
      paddingTop: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2,
      paddingBottom: theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 2,
      textAlign: 'center'
    },
    separator: {
      boxSizing: 'border-box',
      textAlign: 'left',
      width: '100%',
      padding: "".concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }) / 1.5, "px ").concat(theme.fn.size({
        size: size,
        sizes: theme.spacing
      }), "px")
    },
    separatorLabel: {
      color: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[5]
    }
  };
});

export { useStyles as default };
//# sourceMappingURL=SelectItems.styles.js.map
